<script lang="ts">
	import { siteBaseUrl, appName, appAuthor } from '$lib/meta';
	import logo from '$lib/assets/siposdani87-logo.svg';

	let version: string = __APP_VERSION__;
	let startYear = 2021;
	let currentYear: number = new Date().getFullYear();
</script>

<footer class="mt-16 border-t border-border bg-surface text-text">
	<div class="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 py-8 px-5">
		<div>
			<a href="/">
				<img
					class="inline-block logo dark:invert"
					src={logo}
					alt={appName}
					width="192"
					height="192"
				/>
			</a>
			<strong class="pl-2">{appName}</strong>
			<p class="mt-3 text-text-secondary">Software is alive as long as it evolves.</p>
		</div>
		<div>
			<strong>SaaS</strong>
			<div class="flex flex-col">
				<a class="link" href="https://trophymap.org" target="_blank" rel="noopener noreferrer"
					>TrophyMap</a
				>
				<a class="link" href="https://i18nature.com" target="_blank" rel="noopener noreferrer"
					>I18Nature</a
				>
				<a class="link" href="https://rejtvenyepito.hu" target="_blank" rel="noopener noreferrer"
					>Puzzle Builder</a
				>
			</div>
		</div>
		<div>
			<strong>Community</strong>
			<div class="flex flex-col">
				<a
					class="link"
					href="https://blog.siposdani87.com"
					target="_blank"
					rel="noopener noreferrer">Blog</a
				>
				<a
					class="link"
					href="https://github.com/siposdani87"
					target="_blank"
					rel="noopener noreferrer">GitHub</a
				>
				<a
					class="link"
					href="https://discord.gg/g6DhrqGfuN"
					target="_blank"
					rel="noopener noreferrer">Discord</a
				>
			</div>
		</div>
	</div>
	<div class="container mx-auto px-5">
		<div class="border-t border-border"></div>
	</div>
	<div class="py-4">
		<div class="mb-3 text-center text-text-secondary">
			<span class="mr-1">&copy; {startYear} - {currentYear}</span><a href={siteBaseUrl}
				>{appAuthor}</a
			>,
			<span>All rights reserved.</span> <em class="ml-1">v{version}</em>
		</div>
		<div class="text-center text-text-muted">
			Powered by <a href="https://svelte.dev/" target="_blank" rel="noreferrer">Svelte</a> &
			<a href="https://vitejs.dev" target="_blank" rel="noreferrer">Vite</a>
		</div>
	</div>
</footer>

<style lang="postcss">
	@reference "../../app.css";

	footer {
		view-transition-name: footer;
	}
	a {
		@apply text-text-secondary hover:text-primary;
	}

	.logo {
		max-width: 45px;
		border-radius: 5px;
	}

	.link {
		padding: 0.25em 0;
		text-decoration: none;
	}
</style>
